/** @jsx jsx */
import { gql } from '@apollo/client';
import { P } from '@bottlebooks/gatsby-design-system';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function ProductTastingNotes({ product, ...rest }) {
  const { i18n } = useLingui();
  if (!product?.tastingNotes?.length) return null;
  return (
    <Section title={i18n._(t`Tasting Notes`)} {...rest}>
      {product.tastingNotes.map(note => (
        <article key={`${note.publication} - ${note.noteDate}`}>
          <P>{[note.rating, note.publication].filter(Boolean).join(' – ')}</P>
          {note.note && <P>{note.note}</P>}
          {note.author && <P>{note.author}</P>}
        </article>
      ))}
    </Section>
  );
}

export const fragment = graphql`
  fragment ProductTastingNotes on Product {
    tastingNotes {
      noteDate
      note
      author
      publication
      rating
    }
  }
`;

export const ProductTastingNotesFragment = gql`
  fragment ProductTastingNotes on Product {
    tastingNotes {
      noteDate
      note
      author
      publication
      rating
    }
  }
`;
